import './leftBodyCardF1.sass';

/**
 * Muestra la información de la competencia y su ubicación en la tarjeta de Fórmula 1.
*/
export default function LeftBodyCardF1({ data }) {
  const { game_name, venue_name, venue_state, venue_country } = data;

  /**
  * Construye la dirección del evento a partir de los campos disponibles.
  * Se eliminan valores nulos/vacíos y se unen con comas.
  */
  const locationParts = [venue_name, venue_state, venue_country]
    .filter(Boolean)
    .join(', ');

  return (
    <div className='card-f1__body-left'>
      <p className='card-f1__body-left-competition'>{String(game_name).toUpperCase()}</p>
      <p className='card-f1__body-left-address'>{String(locationParts).toUpperCase()}</p>
    </div>
  )
}